import { render, staticRenderFns } from "./AppHeaderPublic.vue?vue&type=template&id=5dfff98a"
import script from "./AppHeaderPublic.vue?vue&type=script&lang=js"
export * from "./AppHeaderPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports